import { Link } from 'react-router-dom';

const ProfileDropdown = ({ handleLogout, setIsMenuOpen, locationInfo }) => {
  return (
    <>
      {/* Mobile View: List without Dropdown */}
      <ul className="flex flex-col sm:hidden space-y-3">
        <li>
          <Link
            to="/info"
            data-attr="nav-info"
            className="text-teal-100 hover:text-white hover:bg-secondary/90 px-4 py-2 rounded-full font-medium transition-all duration-300 ease-in-out transform hover:scale-105 block"
            onClick={() => setIsMenuOpen(false)}
          >
            My Profile
          </Link>
        </li>
        <li>
          <Link
            to="/templates"
            data-attr="nav-templates"
            className="text-teal-100 hover:text-white hover:bg-secondary/90 px-4 py-2 rounded-full font-medium transition-all duration-300 ease-in-out transform hover:scale-105 block"
            onClick={() => setIsMenuOpen(false)}
          >
            Message Templates
          </Link>
        </li>
        <li>
          <Link
            to="/services"
            data-attr="nav-services"
            className="text-teal-100 hover:text-white hover:bg-secondary/90 px-4 py-2 rounded-full font-medium transition-all duration-300 ease-in-out transform hover:scale-105 block"
            onClick={() => setIsMenuOpen(false)}
          >
            Services Management
          </Link>
        </li>
        <li>
          <button
            data-attr="nav-logout"
            onClick={() => {
              handleLogout();
              setIsMenuOpen(false);
            }}
            className="text-teal-100 hover:text-white hover:bg-secondary/90 px-4 py-2 rounded-full font-medium transition-all duration-300 ease-in-out transform hover:scale-105 block"
          >
            Logout
          </button>
        </li>
      </ul>

      {/* Desktop View: Profile Dropdown */}
      <div className="hidden sm:block relative group">
        <button data-attr="nav-profile-menu" className="flex items-center text-teal-100 hover:text-white hover:bg-secondary/90 px-4 py-2 rounded-full font-medium transition-all duration-300 ease-in-out transform hover:scale-105">
          <span className="ph-mask mr-2">{locationInfo?.user_name || "Profile"}</span>
          <span className="mr-2">Profile</span>
          <svg className="w-4 h-4 fill-current" viewBox="0 0 20 20">
            <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
          </svg>
        </button>

        {/* Dropdown Menu */}
        <div className="absolute right-0 mt-0 w-48 bg-white rounded-lg shadow-sm py-2 z-[100] hidden group-hover:block">
          <Link
            to="/info"
            data-attr="nav-info"
            className="block px-4 py-2 text-gray-800 hover:bg-accent-teal-light-bg hover:text-primary flex items-center"
            onClick={() => setIsMenuOpen(false)}
          >
            <svg
              className="w-4 h-4 mr-3"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
              />
            </svg>
            My Profile
          </Link>

          <Link
            to="/templates"
            data-attr="nav-templates"
            className="block px-4 py-2 text-gray-800 hover:bg-accent-teal-light-bg hover:text-primary flex items-center"
            onClick={() => setIsMenuOpen(false)}
          >
            <svg
              className="w-4 h-4 mr-3"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
              />
            </svg>
            Message Templates
          </Link>

          <Link
            to="/services"
            data-attr="nav-services"
            className="block px-4 py-2 text-gray-800 hover:bg-accent-teal-light-bg hover:text-primary flex items-center"
            onClick={() => setIsMenuOpen(false)}
          >
            <svg
              className="w-4 h-4 mr-3"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
              />
            </svg>
            Services Management
          </Link>

          <hr className="my-2 border-border" />

          <button
            data-attr="nav-logout"
            onClick={() => {
              handleLogout();
              setIsMenuOpen(false);
            }}
            className="block w-full text-left px-4 py-2 text-gray-800 hover:bg-accent-teal-light-bg hover:text-primary flex items-center"
          >
            <svg
              className="w-4 h-4 mr-3"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
              />
            </svg>
            Logout
          </button>
        </div>
      </div>
    </>
  );
};

export default ProfileDropdown;